<template>
	<div class="fan">
		<template v-if="!giftingEnabled">
			<UiEmpty></UiEmpty>
		</template>
		<template v-else>
			<FanTopThree :items="fanListTop3" :default-avatar="defaultUrl" show-prefix />
			<FanList :items="filteredList" :default-avatar="defaultUrl" />
		</template>
	</div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAppStore, useStageStore } from '@/store'
import UiEmpty from '@/components/ui-empty'
import FanTopThree from '@/views/ranking/fan-top-three.vue'
import FanList from '@/views/ranking/fan-list.vue'
import * as api from '@/service/index'


const route = useRoute()
const appStore = useAppStore()
const stageStore = useStageStore()

const defaultUrl = ref('https://website.xdcdn.net/form/match/avatar/Portrait1.png')
const subSeasonID = ref('')
const fan = ref([])
const personalGifts = ref({})

const token = computed(() => appStore.token)
const seasonInfo = computed(() => appStore.seasonInfo)
const giftingEnabled = computed(() => stageStore.giftingEnabled)

const fanListTop3 = computed(() => fan.value.filter((item, index) => index <= 2))
const filteredList = computed(() => fan.value.filter((item, index) => index > 2))

watch(
	seasonInfo,
	(newVal) => {
		if (newVal && newVal.id) {
			subSeasonID.value = newVal.id
			// 获取粉丝排名
			// 考虑到粉丝数量随时变化，所以就每次都重新调一下
			fetchGiftTeamListData(route.params.id)
		}
	},
	{
		immediate: true,
		deep: true
	}
)

async function fetchGiftTeamListData(teamID) {
	if(!token.value) return;
	try {
		const data = {
			token: token.value,
			rankType: 'season',
			teamCode: teamID
		}
		let res = await api.getGiftTeamDetail(data)
		personalGifts.value = res.data.personal || {}
		fan.value = res.data.totalList || []
		let fanLength = fan.value.length;
		if(fanLength <= 3) {
			for(let i = 0; i < 3 - fanLength; i++) {
				fan.value.push({
					avatarUrl: defaultUrl.value,
					nickName: '-',
					popularity: 0
				})
			}
		}
	} catch (err) {
		console.log(err)
	}
}
</script>

<style lang="scss" scoped>
@import "./fan";
</style>
